import type { BaseSyntheticEvent, ReactNode, RefObject } from 'react';
import styled from 'styled-components';

import { button } from '@/styles/shared';

export const FormWrapper = styled.div`
  padding: 0 5px;

  @media ${({ theme }) => theme.media.tablet} {
    padding: 0 10px;
  }
`;

export const Form = styled.form<{
  children: ReactNode;
  onSubmit: (e?: BaseSyntheticEvent) => Promise<void>;
}>`
  margin: 20px auto 0;

  @media ${({ theme }) => theme.media.tablet} {
    margin-top: 40px;
  }

  input {
    margin: 10px 0 0 0;
    width: 100%;
    position: relative;
  }
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  label {
    font-size: 12px;
    width: 100%;
    position: relative;
    margin: 20px 0;

    span {
      position: absolute;
      top: -8px;
    }
  }
`;

export const TextArea = styled.textarea<{
  id: string;
  placeholder: string;
  ref?:
    | RefObject<HTMLTextAreaElement>
    | ((instance: HTMLTextAreaElement | null) => void);
  rows: number;
}>`
  margin-top: 12px;
  border: 1px solid ${({ theme }) => theme.palette.lightGray};
  border-radius: 6px;
  min-width: 240px;
  padding-left: 10px;
  padding-top: 10px;
  outline-color: ${({ theme }) => theme.palette.primary};
  outline-offset: 4px;
  max-width: calc(100vw - 10px);
  width: 100%;
  font-family: Roboto, Helvetica, sans-serif;
  font-weight: 400;
  font-size: 14px;
  grid-area: messageInput;
  height: 100%;
  resize: none;

  :invalid {
    border-color: ${({ theme }) => theme.palette.primary};
  }

  @media ${({ theme }) => theme.media.tablet} {
    margin-top: 10px;
  }
`;

export const SubmitButtonWrapper = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;

  button {
    ${button};
    padding: 11px 64px;
  }
`;

export const ErrorMessage = styled.span<{
  children: ReactNode;
  className: string;
}>`
  &.error {
    font-size: 12px;
    color: ${({ theme }) => theme.palette.primary};
    width: 100%;
    position: absolute;
    text-align: right;
    right: 3px;
    top: -8px;
  }
`;

export const MessageWrapper = styled.p`
  font-family: Roboto, Helvetica, sans-serif;
  text-align: end;
  width: 100%;
`;
